const EditGroupActionTypes = {
  FETCH_EDIT_GROUP_START: 'FETCH_EDIT_GROUP_START',
  FETCH_EDIT_GROUP_SUCCESS: 'FETCH_EDIT_GROUP_SUCCESS',
  FETCH_EDIT_GROUP_FAILED: 'FETCH_EDIT_GROUP_FAILED',
  DESTROY_EDIT_GROUP: 'DESTROY_EDIT_GROUP'
};

export default EditGroupActionTypes;
